import {gsap} from "gsap";
import {BruteForceGameMode} from "../server/BruteForceGameMode";
import {BruteForce} from "../BruteForce";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";

export class BruteForceBonusIntroPresentation implements SimplePresentation {
    name: string = "BonusIntroPresentation";

    shouldRun(): boolean {
        return (BruteForce.model.mode === BruteForceGameMode.NORMAL && (BruteForce.model.nextMode === BruteForceGameMode.FREESPIN || BruteForce.model.nextMode === BruteForceGameMode.FREESPIN_SUPER));
    }

    start(controller: SimplePresentationRunnerController): void {
        const showTl: gsap.core.Timeline = gsap.timeline();
        controller.setSkipCallback();
        showTl.add(BruteForce.bonusIntroView.show());
        showTl.add(BruteForce.transitionView.enableButton(() => this.complete(controller)));
    }

    public complete(controller: SimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(BruteForce.bonusIntroView.hideFSIntro());
        tl.add(() => {
            controller.setSkipCallback();
            BruteForce.keypadPlugin.show(0.2);
            controller.finish();
        });
    }
}